import ProductsList from './ProductsList';
import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import { warrantyProvidersSel } from 'src/store/modules/warranty';
import warrantyActions from 'src/store/modules/warranty/actions';

interface IDispatchFromProps {
  getWarranyProviders: () => void;
}

const mapStateToProps = (state: IInitialState) => ({
  warrantyProviders: warrantyProvidersSel(state)
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getWarranyProviders: () => dispatch(warrantyActions.getWarranty())
});

export const pureComponent = ProductsList;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(ProductsList));
